import { ShieldCheck } from "lucide-react";
import LegalPage from "@/pages/legal/LegalPage";

export default function SafeInternet() {
  return (
    <LegalPage title="Güvenli İnternet" testId="legal-safe-internet">
      <div className="flex items-start gap-4 rounded-2xl border border-zinc-200 bg-[#F0FDFA] p-7">
        <ShieldCheck className="h-8 w-8 shrink-0 text-[#2DD4BF]" />
        <div>
          <h2 className="font-display text-lg font-bold text-[#062B2B]">Güvenli İnternet Hizmeti Nedir?</h2>
          <p className="mt-2">
            İnternet servis sağlayıcıları tarafından ücretsiz olarak sunulan ve internetteki zararlı
            içeriklerden sizi ve ailenizi büyük oranda koruyan alternatif bir internet erişimidir.
            Bilgi Teknolojileri ve İletişim Kurumu (BTK) tarafından sunulmakta olan Güvenli İnternet
            Hizmeti (GİH), başta çocuklar ve gençler olmak üzere dijital çağın sunduğu fırsatlardan
            tüm internet kullanıcılarının güvenli bir ortamda yararlanmasını sağlamak amacıyla
            geliştirilmiştir.
          </p>
        </div>
      </div>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Hangi Profillerden Oluşmaktadır?</h2>
      <p>
        Güvenli İnternet Hizmeti, Çocuk ve Aile olmak üzere iki farklı profil seçeneği ile
        sunulmaktadır. Çocuk ve Aile Profillerine ait kriterler psikoloji, pedagoji, sosyoloji ve
        hukuk alanlarında uzman akademisyenlerin bulunduğu bir kurul tarafından tespit edilmektedir.
      </p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-zinc-200 bg-white p-6">
          <h3 className="font-display text-base font-bold text-[#062B2B]">Çocuk Profili</h3>
          <p className="mt-2 text-sm leading-relaxed text-gray-500">
            "İzinli liste" yöntemi ile çalışmaktadır. Güvenli olduğu onaylanmış belirli sayıdaki
            internet sitelerine erişim sağlanır. Bu listede yer almayan sitelere erişim sağlanamaz.
            İnternetteki risklere karşı en yüksek korumayı sağlayan profildir. Sohbet siteleri ile
            sosyal medya siteleri bu profilde yer almazlar.
          </p>
        </div>
        <div className="rounded-xl border border-zinc-200 bg-white p-6">
          <h3 className="font-display text-base font-bold text-[#062B2B]">Aile Profili</h3>
          <p className="mt-2 text-sm leading-relaxed text-gray-500">
            "Yasaklı liste" yöntemi ile çalışmaktadır. Zararlı içerik barındıran sitelere
            erişilememekte, bu liste haricindeki tüm sitelere erişilebilmektedir. Çocuk Profilinden
            daha geniş içeriğe sahiptir. Forum ve paylaşım sitelerine erişilebilir. Oyun, Sosyal Medya
            ve Sohbet siteleri isteğe bağlı olarak erişime kapatılabilir.
          </p>
        </div>
      </div>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Sıkça Sorulan Sorular</h2>
      <div className="space-y-4">
        <div>
          <h3 className="font-bold text-[#062B2B]">Hukuki dayanağı nedir?</h3>
          <p>
            Elektronik Haberleşme Kanunu uyarınca çıkarılan Elektronik Haberleşme Sektörüne İlişkin
            Tüketici Hakları Yönetmeliği'nin "İnternetin güvenli kullanımı" başlıklı 15. maddesi,
            tüm internet servis sağlayıcılara internetin güvenli kullanımına yönelik ücretsiz
            alternatif hizmet sunma yükümlülüğü getirmektedir.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-[#062B2B]">Kullanımı zorunlu mudur?</h3>
          <p>
            Güvenli İnternet Hizmeti sadece talep eden abonelere sunulmakta olup, zorunlu değildir.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-[#062B2B]">Ücretli midir?</h3>
          <p>Güvenli İnternet Hizmeti, tercih eden abonelere ücretsiz olarak sunulmaktadır.</p>
        </div>
      </div>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Nasıl Tercih Edebilirim?</h2>
      <p>Güvenli İnternete farklı yöntemlerle geçebilirsiniz:</p>
      <ul className="list-disc space-y-2 ps-6">
        <li>Servis sağlayıcınızın bayisine başvurarak</li>
        <li>Çağrı merkezine telefon ederek</li>
        <li>Online işlem merkezine müşteri numaranız ve şifresi ile giriş yaparak</li>
        <li>Kısa mesaj (SMS) atarak</li>
      </ul>
      <p>
        Aynı yolla, istediğiniz zaman, ücretsiz olarak profilinizi değiştirebilir ya da hizmet almayı
        bırakabilirsiniz. Detaylı bilgi için guvenlinet.org adresini ziyaret edebilirsiniz.
      </p>
    </LegalPage>
  );
}
